export enum LoginNotes {
    LOGIN_TO_CONNECT_SSO_ACCOUNT = 'login_to_connect_sso_account',
    SESSION_EXPIRED = 'session_expired',
    SSO_SIGNUP_DISABLED = 'sso_signup_disabled',
}
